// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\ServicesV2\Products\DataProviders\ProductField
// Generated on: <normalized>

export enum ProductField {
  DB_TABLE = 'products',
  DB_IDENTIFIER = 'productGUID',
  PRODUCT_NAME = 'productName',
  DISPLAY_NAME = 'displayName',
  PRODUCT_CATEGORY_GUID = 'productCategoryGUID',
  BUSINESS_GUID = 'businessGUID',
  PRICE = 'price',
  DEPOSIT_PRICE = 'depositPrice',
  DISPLAY_ORDER = 'displayOrder',
  TOOL_TIP = 'toolTip',
  PAGE_META_CANONICAL = 'pageMetaCanonical',
  PAGE_META_DESCRIPTION = 'pageMetaDescription',
  HTML_DESCRIPTION = 'htmlDescription',
  SHORT_DISPLAY_DESCRIPTION = 'shortDisplayDescription',
  INSTAGRAM_HASH_TAG = 'instagramHashTag',
  INSTAGRAM_ACCOUNT_GUID = 'instagramAccountGUID',
  PRODUCT_SPECS = 'productSpecs',
  ALIAS_GUIDS = 'aliasGUIDs',
  BOOKING_OPTIONS = 'bookingOptions',
  JOB_TYPE_ID = 'jobTypeID',
  HIDDEN = 'isHidden',
  CONTRACT_SETTINGS = 'contractSettings',
  DELIVERY_SETTINGS = 'deliverySettings',
  BOOKING_SETTINGS = 'bookingSettings',
  THUMBNAIL_FILE_DATA = 'thumbnailFileData',
  PRIMARY_IMAGE_FILE_DATA = 'primaryImageFileData',
  SLAVE_DATA = 'slaveData',
  TYPE = 'productType',
  SLUG = 'productSlug',
}

export const ProductFieldGetEncryptionFields = [] as const;

export const ProductFieldCases = ["products", "productGUID", "productName", "displayName", "productCategoryGUID", "businessGUID", "price", "depositPrice", "displayOrder", "toolTip", "pageMetaCanonical", "pageMetaDescription", "htmlDescription", "shortDisplayDescription", "instagramHashTag", "instagramAccountGUID", "productSpecs", "aliasGUIDs", "bookingOptions", "jobTypeID", "isHidden", "contractSettings", "deliverySettings", "bookingSettings", "thumbnailFileData", "primaryImageFileData", "slaveData", "productType", "productSlug"] as const;
